import { FC } from "react";

import { Trans, useTranslation } from "react-i18next";

import Image from "../BaseComponents/Image";

import nortonLogo from "assets/images/logo/norton.png";

import {
  StyledOuterContainer,
  StyledText,
  StyledTextWrapper,
} from "./Footer.styles";

const Footer: FC = () => {
  const { t } = useTranslation();

  return (
    <StyledOuterContainer>
      <StyledTextWrapper>
        <StyledText>
          <Trans
            i18nKey='footer_info_text'
            values={{
              datetimeNow: new Date(Date.now()).getFullYear().toString(),
            }}
          />
        </StyledText>
        <StyledText>{t("footer_management_adress_text")}</StyledText>
      </StyledTextWrapper>
      <Image alt='Norton Logo' height='45' srcSet={nortonLogo} width='80' />
    </StyledOuterContainer>
  );
};

export default Footer;
